var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchTermbase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "m15.9 17.3-5.6-5.6q-.75.6-1.725.95T6.5 13q-2.725 0-4.612-1.887T0 6.5t1.888-4.613Q3.775 0 6.5 0t4.613 1.887T13 6.5a6.1 6.1 0 0 1-1.3 3.8l5.625 5.625a.92.92 0 0 1 .275.675q0 .4-.3.7a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275M6.5 11q1.875 0 3.188-1.312Q11 8.375 11 6.5T9.688 3.312Q8.375 2 6.5 2T3.312 3.312Q2 4.625 2 6.5t1.312 3.188Q4.625 11 6.5 11"
})));
export default SvgSearchTermbase;